import React from 'react';
import PropTypes from 'prop-types';
import SMFormSpaceSelectBox from 'components/dashboard/form/SMFormSpaceSelectBox';
import SMFormRoomSelectBox from 'components/dashboard/form/SMFormRoomSelectBox';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewSpace extends React.Component{

  roomSelectBoxDidChangeValue(value) {
    this.props.delegate.changeRoom(value);
  }

  spaceSelectBoxDidChangeValue(value) {
    this.props.delegate.changeSpace(value);
  }

  render() {
    const ownerId = this.props.ownerId;
    const spaceId = this.props.spaceId;
    const roomId = this.props.roomId;
    const reservation = this.props.reservation;
    const errors = this.props.errors;
    const isUser = this.props.isUser;

    return(
      <td>
        <span className="form-select__inner mr10">
          <label className="form-select">
            <SMFormSpaceSelectBox
              ownerId={ownerId}
              spaceId={spaceId}
              options={{ className: "w200", disabled: !SMReservationHelper.isDetailEditable(reservation) }}
              delegate={this} />
          </label>
        </span>
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormRoomSelectBox
              ownerId={ownerId}
              spaceId={spaceId}
              roomId={roomId}
              options={{ className: "w200", disabled: !SMReservationHelper.isDetailEditable(reservation)}}
              isUser={isUser}
              delegate={this}
            />
          </label>
        </span>
        <span className="message-important ml10">
          {SMFormatHelper.errorText('Reservation', 'space', errors)}
        </span>
        <span className="message-important ml10">
          {SMFormatHelper.errorText('Reservation', 'room', errors)}
        </span>
      </td>
    );
  }
}

SMReservationEditViewSpace.propTypes = {
  ownerId: PropTypes.string.isRequired,
  spaceId: PropTypes.string,
  roomId: PropTypes.string,
  isUser: PropTypes.bool.isRequired,
  reservation: PropTypes.object.isRequired,
  errors: PropTypes.array,
  delegate: PropTypes.object
};
export default SMReservationEditViewSpace;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewSpace.jsx